'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('housing_requirements', {
      url: '/account/housing/housing_requirements',
      template: '<housing-requirements></housing-requirements>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/housing/housing_requirements/housing_requirements.routes.js